import React, { useEffect, useMemo, useRef, useState } from "react";
import "./AddGuestList.css";
import { IoShareSocialOutline } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa6";
import { FiPlusCircle } from "react-icons/fi";
import { BsThreeDots } from "react-icons/bs";
import { API_BASE_URL } from "../../utils";
import { useParams } from "react-router-dom";
import axios from "axios";
import AddGuestListModal from "./AddGuestListModal";
import GiveGuestAddPermission from "./GiveGuestAddPermission";

const url = `${API_BASE_URL}/master/assets/uploads/`;

export default function AddGuestList() {

    const { id } = useParams();

    const userData = JSON.parse(localStorage.getItem("userData"));

    const [openAddGuest, setOpenAddGuest] = useState(false);
    const [openGivePermission, setOpenGivePermission] = useState(null);


    const [data, setData] = useState(null);
    const [inviteeData, setInviteeData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [guests, setGuests] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("Male");

    const [userType, setUserType] = useState(null);


    const handleOpen = (cat) => {
        setSelectedCategory(cat);
        setIsModalOpen(true);
    };


    const handleSave = (guests) => {
        try {
            const payload = {
                order_id: id,
                guests: guests
            };

            axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/addGuestToList`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            )
                .then((response) => {
                    if (response?.data?.status) {
                        setData(response.data.data);
                        handleFetchGuestList();
                        getGuestPermissionDetail();
                    } else {
                        setError(response?.data?.msg || "Failed to save guests.");
                    }
                });
        } catch (err) {
            console.log(err);
        }
    };

    const handleFetchGuestList = async () => {
        try {
            const formData = new FormData();
            formData.append("order_id", id);
            formData.append("user_id", userData?.id);
            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/getGuestListDetail`,
                formData
            );
            if (response?.data?.status) {
                setData(response.data.data);
                setUserType(response.data.data.current_user_role);
            } else {
                setError(response?.data?.msg || "Failed to load menu.");
            }
        } catch (err) {
            console.error(err);
            setError("Something went wrong while fetching the menu.");
        } finally {
            setLoading(false);
        }
    }


    const handlegiveGuestPermission = async (data) => {
        const payload = {
            order_id: id, // booking/order id (string from props/state)
            guest_id: String(data.givenTo), // always send as string or int safely
            allowed_male: parseInt(data.male || 0, 10),
            allowed_female: parseInt(data.female || 0, 10),
        };

        try {
            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/giveGuestPermission`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data?.status) {
                setOpenAddGuest(false);
                handleFetchGuestList();
                getGuestPermissionDetail();
            } else {
                console.warn("⚠️ API Error:", response?.data?.msg || "Unknown error");
            }
        } catch (err) {
            console.error("❌ Request failed:", err.message || err);
        }
    };




    useEffect(() => {
        handleFetchGuestList();
    }, []);


    const handleEditGuest = (guest) => {
        console.log("edit", guest);
    };

    // 🔹 Handle Delete
    const handleDeleteGuest = (guest) => {
        try {

            const fromData = new FormData();
            fromData.append("guest_id", guest.id);
            fromData.append("order_id", id);
            fromData.append("user_id", userData?.id);

            axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/deleteGuest`,
                fromData,

            )
                .then((response) => {
                    if (response?.data?.status) {
                        handleFetchGuestList();
                        getGuestPermissionDetail();
                        console.log("guest deleted");
                    } else {
                        setError(response?.data?.msg || "Failed to save guests.");
                    }
                });
        } catch (err) {
            console.log(err);
        }
    };



    const getGuestPermissionDetail = async () => {
        try {
            const formData = new FormData();
            formData.append("order_id", id);
            formData.append("user_id", userData?.id);
            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/getGuestPermissionDetail`,
                formData
            );
            if (response?.data?.status) {
                setInviteeData(response.data.data);
                console.log("data received", response.data.data);

            } else {
                setError(response?.data?.msg || "Failed to load menu.");
            }
        } catch (err) {
            console.error(err);
            setError("Something went wrong while fetching the menu.");
        }
    }


    useEffect(() => {
        if (userType === "Invitee") {
            getGuestPermissionDetail();
        }
    }, [userType]);



    const maleGuests = [
        { name: "You", phone: "+91 9876543210", role: "Host", avatar: "Y", status: "yes" },
        { name: "Rohan Sharma", phone: "+91 9876543211", role: "Invites", avatar: "RS", status: "pending" },
        { name: "Mike Chen", phone: "+91 9876543214", role: "Accompany", avatar: "M", status: "yes" },
        { name: "Mike Chen", phone: "+91 9876543214", role: "Invites", avatar: "M", status: "no" },
        { name: "Rohan’s Invite", phone: "", role: "Accompany", avatar: "M", status: "pending" },
    ];

    const femaleGuests = [
        { name: "You", phone: "+91 9876543210", role: "Host", avatar: "Y", status: "yes" },
    ];

    const rsvpList = [
        { name: "Wilson Nadar", status: "yes" },
        { name: "Wilson Nadar", status: "no" },
        { name: "Alice Johnson", status: "yes" },
        { name: "Alice Johnson", status: "no" },
        { name: "Marcus Lee", status: "yes" },
        { name: "Marcus Lee", status: "no" },
    ];

    // ------- Derived counts -------
    const maleCount = maleGuests.length;
    const femaleCount = femaleGuests.length;

    // ------- Helpers -------
    const StatusPill = ({ value }) => (
        <span className={`agl-badge ${value === "Confirmed" ? "is-success" : ""}`}>{value}</span>
    );

    const RSVPTag = ({ s }) => (
        <span className={`agl-rsvp ${s === "Yes" ? "yes" : s === "No" ? "no" : "pending"}`}>
            {s}
        </span>
    );

    const SectionHeader = ({ title, sub, color }) => (
        <div className="agl-section-head">
            <div className="agl-section-title">
                <h4>{title}</h4>
            </div>
            <div className="agl-section-sub">{sub}</div>
        </div>
    );


    const GuestRow = ({ g, male, onEdit, onDelete }) => {
        const [showMenu, setShowMenu] = useState(false);
        const menuRef = useRef(null);

        const toggleMenu = () => {
            setShowMenu((prev) => !prev);
        };

        const handleEdit = () => {
            setShowMenu(false);
            onEdit(g);
        };

        const handleDelete = () => {
            setShowMenu(false);
            onDelete(g);
        };

        // ✅ Close menu when clicking outside
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (menuRef.current && !menuRef.current.contains(event.target)) {
                    setShowMenu(false);
                }
            };

            if (showMenu) {
                document.addEventListener("mousedown", handleClickOutside);
            } else {
                document.removeEventListener("mousedown", handleClickOutside);
            }

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [showMenu]);

        return (
            <div className="agl-guest-row">
                <div className="agl-guest-left">
                    <span className="agl-avatar">
                        {(g.avatar || g.guest_name?.[0] || "?").slice(0, 2)}
                    </span>
                    <div className="agl-guest-meta">
                        <div className="agl-guest-name">{g.guest_name || "Invite"}</div>
                        {g.guest_phone && <div className="agl-guest-phone">{g.guest_phone}</div>}
                    </div>
                </div>
                {userType === "Host" &&
                    <div className="agl-guest-actions" ref={menuRef}>
                        <button className="agl-icon-btn" onClick={toggleMenu} title="More">
                            <BsThreeDots />
                        </button>
                        {showMenu && (
                            <div className="agl-tooltip-menu">
                                <button onClick={handleEdit}>Edit</button>
                                <button onClick={handleDelete}>Delete</button>
                            </div>
                        )}
                    </div>
                }
            </div>
        );
    };


    const GuestRowHost = ({ g, male }) => (

        <div className="agl-guest-row">
            <div className="agl-guest-left">
                <span className="agl-avatar">{(g.avatar || g.guest_name?.[0] || "?").slice(0, 2)}</span>
                <div className="agl-guest-meta">
                    <div className="agl-guest-name">{g.guest_name || "Invite"}</div>
                    {g.guest_phone && <div className="agl-guest-phone">{g.guest_phone}</div>}
                </div>
            </div>
            <div className="agl-guest-actions">
                {userType === "Host" &&
                    <>
                        <button className="agl-icon-btn" onClick={() => handleOpen(male ? "male" : "female")} title="Message"><FiPlusCircle /></button>
                        <button className="agl-icon-btn" title="More"><BsThreeDots /></button>
                    </>
                }
            </div>
        </div>
    );


    const GuestRowInvite = ({ g, male, onEdit, onDelete, setOpenGivePermission }) => {
        const [showMenu, setShowMenu] = useState(false);
        const menuRef = useRef(null);

        const toggleMenu = () => {
            setShowMenu((prev) => !prev);
        };

        const handleEdit = () => {
            setShowMenu(false);
            onEdit(g);
        };

        const handleDelete = () => {
            setShowMenu(false);
            onDelete(g);
        };

        const CurrentGuest = () => {
            setOpenAddGuest(true);
            setOpenGivePermission(g);
        };

        const CurrentGuestinvite = () => {
            setSelectedCategory(male ? "male" : "female");
            setIsModalOpen(true);
        };

        // ✅ Close menu when clicking outside
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (menuRef.current && !menuRef.current.contains(event.target)) {
                    setShowMenu(false);
                }
            };

            if (showMenu) {
                document.addEventListener("mousedown", handleClickOutside);
            } else {
                document.removeEventListener("mousedown", handleClickOutside);
            }

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [showMenu]);

        return (
            <div className="agl-guest-row">
                <div className="agl-guest-left">
                    <span className="agl-avatar">
                        {(g.avatar || g.guest_name?.[0] || "?").slice(0, 2)}
                    </span>
                    <div className="agl-guest-meta">
                        <div className="agl-guest-name">{g.guest_name || "Invite"}</div>
                        {g.guest_phone && <div className="agl-guest-phone">{g.guest_phone}</div>}
                    </div>
                </div>


                <div className="agl-guest-actions" ref={menuRef}>

                    {userType === "Host" &&
                        <>
                            <button className="agl-icon-btn" onClick={userType === "Host" ? CurrentGuest : CurrentGuestinvite} title="Message"><FiPlusCircle /></button>

                            <button className="agl-icon-btn" onClick={toggleMenu} title="More">
                                <BsThreeDots />
                            </button>
                        </>
                    }
                    {showMenu && (
                        <div className="agl-tooltip-menu">
                            <button onClick={handleEdit}>Edit</button>
                            <button onClick={handleDelete}>Delete</button>
                        </div>
                    )}
                </div>
            </div>
        );
    };


    return (
        <>
            <div className="agl-app">
                <header className="agl-header">
                    <h1>{data?.package_title_name}</h1>
                </header>

                <div className="agl-grid">
                    {/* LEFT: Event + Guest Management */}
                    <div className="agl-left">
                        {/* Event card */}
                        <section className="agl-card agl-event-card">
                            <div className="agl-event-top">
                                <div className="agl-event-photos-wrap">

                                    <div className="agl-event-photos">

                                        <img src={url + data?.package_img} alt={`photo-package`} />
                                        <img src={url + data?.img} alt={`photo-club`} />

                                    </div>

                                    <div className="agl-event-title-wrap">
                                        <div>
                                            <h3 className="agl-event-title">{data?.package_title_name}</h3>
                                            <div className="agl-event-venue">{data?.club_name}</div>
                                            <div className="agl-tag-row">
                                                {/* {event.tags.map((t) => ( */}
                                                <span
                                                    // key={t} 
                                                    className="agl-tag"> {data?.package_type}</span>
                                                {/* ))} */}
                                            </div>
                                        </div>
                                        <StatusPill value={"Confirmed"} />
                                    </div>
                                </div>

                                <div className="agl-event-info">


                                    <div className="agl-info-grid">
                                        <div className="agl-info-block">
                                            <div className="agl-info-label">Date</div>
                                            <div className="agl-info-value">
                                                <strong>{data?.party_date}</strong>
                                                <span>
                                                    {data?.party_date
                                                        ? new Date(data.party_date).toLocaleDateString("en-US", { weekday: "long" })
                                                        : ""}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="agl-info-block">
                                            <div className="agl-info-label">Time</div>
                                            <div className="agl-info-value">
                                                <strong>{data?.party_time}</strong>
                                                <span>{"3 hrs"}</span>
                                            </div>
                                        </div>
                                        <div className="agl-info-block">
                                            <div className="agl-info-label">Venue contact</div>
                                            <div className="agl-info-value">
                                                <strong>{data?.user_mobile}</strong>
                                            </div>
                                        </div>
                                        <div className="agl-info-block">
                                            <div className="agl-info-label">Location</div>
                                            <div className="agl-info-value">
                                                <strong>{data?.club_address}</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="agl-count-row">
                                        <div className="agl-count-box">
                                            <div className="agl-count-label">Current Guest Count</div>
                                            <div className="agl-count-total">Total: {Number(data?.male) + Number(data?.female)}</div>
                                        </div>
                                        <div className="agl-count-box-wrap">
                                            <div className="agl-mini-count male">
                                                <div className="agl-mini-number">{data?.male || 0}</div>
                                                <div className="agl-mini-label">Male</div>
                                            </div>
                                            <div className="agl-mini-count female">
                                                <div className="agl-mini-number">{data?.female || 0}</div>
                                                <div className="agl-mini-label">Female</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Guest management toolbar */}
                        <section className="agl-card agl-manage">
                            <div className="agl-manage-left">
                                <h4>Guest Management</h4>
                                <p>Add and manage your party guests collaboratively</p>
                            </div>

                            <div className="agl-manage-right-wrap">
                                {/* Host Condition */}
                                {userType === "Host" &&
                                    Number(data?.guest_summary?.total) < (Number(data?.male) + Number(data?.female)) && (
                                        <button className="agl-btn-add-guest" onClick={() => setIsModalOpen(true)}>
                                            Add Guest Manual
                                        </button>
                                    )}


                                {/* Invitee Condition */}
                                {userType === "Invitee" &&
                                    (Number(inviteeData?.allowed_male) > 0 || Number(inviteeData?.allowed_female) > 0) &&
                                    Number(data?.guest_summary?.total) < (Number(data?.male) + Number(data?.female)) && (
                                        <button className="agl-btn-add-guest" onClick={() => setIsModalOpen(true)}>
                                            Add Guest Manual
                                        </button>
                                    )}

                                <p>Use App To Import from Phone Book</p>
                            </div>
                        </section>


                        {/* Male / Female lists  For Host */}
                        {userType === "Host" && (
                            <div className="agl-two-col">
                                {/* Male Guests */}
                                <section className="agl-card agl-list-card">
                                    <SectionHeader
                                        title="Male Guests"
                                        sub={`${data?.guest_list?.filter((g) => g?.guest_gender === "male").length} Invited • of ${data?.male} Male Guest`}
                                        color="#c7d2fe"
                                    />

                                    <div className="agl-guest-group">
                                        {data?.guest_list?.filter((g) => g?.guest_gender === "male").length === 0 ? (
                                            <div className="agl-subtitle">No Male Guests</div>
                                        ) : (
                                            <>
                                                {/* Host */}
                                                {userType === "Host" &&
                                                    data?.guest_list
                                                        ?.filter((g) => g.guest_gender === "male" && g.guest_type === "Host")
                                                        .map((g, idx) => (
                                                            <React.Fragment key={`male-host-${idx}`}>
                                                                <div className="agl-subtitle">Host</div>
                                                                <GuestRowHost g={g} male={true} />
                                                            </React.Fragment>
                                                        ))}

                                                {/* Invitee */}
                                                {data?.guest_list
                                                    ?.filter((g) => g.guest_gender === "male" && g.guest_type === "Invitee")
                                                    .map((g, idx) => (
                                                        <React.Fragment key={`male-invitee-${idx}`}>
                                                            {idx === 0 && <div className="agl-subtitle">Invitee</div>}
                                                            <GuestRowInvite
                                                                g={g}
                                                                male={true}
                                                                onEdit={handleEditGuest}
                                                                onDelete={handleDeleteGuest}
                                                                setOpenGivePermission={setOpenGivePermission}
                                                            />
                                                        </React.Fragment>
                                                    ))}

                                                {/* Accompany */}
                                                {data?.guest_list
                                                    ?.filter((g) => g.guest_gender === "male" && g.guest_type === "Accompany")
                                                    .map((g, idx) => (
                                                        <React.Fragment key={`male-accompany-${idx}`}>
                                                            {idx === 0 && <div className="agl-subtitle">Accompany</div>}
                                                            <GuestRow
                                                                g={g}
                                                                male={true}
                                                                onEdit={handleEditGuest}
                                                                onDelete={handleDeleteGuest}
                                                            />
                                                        </React.Fragment>
                                                    ))}
                                            </>
                                        )}
                                    </div>
                                </section>

                                {/* Female Guests */}
                                <section className="agl-card agl-list-card">
                                    <SectionHeader
                                        title="Female Guests"
                                        sub={`${data?.guest_list?.filter((g) => g?.guest_gender === "female").length} Invited • of ${data?.female} Female Guest`}
                                        color="#fbcfe8"
                                    />

                                    <div className="agl-guest-group">
                                        {data?.guest_list?.filter((g) => g?.guest_gender === "female").length === 0 ? (
                                            <div className="agl-subtitle">No Female Guests</div>
                                        ) : (
                                            <>
                                                {/* Host */}
                                                {userType === "Host" &&
                                                    data?.guest_list
                                                        ?.filter((g) => g.guest_gender === "female" && g.guest_type === "Host")
                                                        .map((g, idx) => (
                                                            <React.Fragment key={`female-host-${idx}`}>
                                                                <div className="agl-subtitle">Host</div>
                                                                <GuestRowHost g={g} male={false} />
                                                            </React.Fragment>
                                                        ))}

                                                {/* Invitee */}
                                                {data?.guest_list
                                                    ?.filter((g) => g.guest_gender === "female" && g.guest_type === "Invitee")
                                                    .map((g, idx) => (
                                                        <React.Fragment key={`female-invitee-${idx}`}>
                                                            {idx === 0 && <div className="agl-subtitle">Invitee</div>}
                                                            <GuestRowInvite
                                                                g={g}
                                                                male={false}
                                                                onEdit={handleEditGuest}
                                                                onDelete={handleDeleteGuest}
                                                                setOpenGivePermission={setOpenGivePermission}
                                                            />
                                                        </React.Fragment>
                                                    ))}

                                                {/* Accompany */}
                                                {data?.guest_list
                                                    ?.filter((g) => g.guest_gender === "female" && g.guest_type === "Accompany")
                                                    .map((g, idx) => (
                                                        <React.Fragment key={`female-accompany-${idx}`}>
                                                            {idx === 0 && <div className="agl-subtitle">Accompany</div>}
                                                            <GuestRow
                                                                g={g}
                                                                male={false}
                                                                onEdit={handleEditGuest}
                                                                onDelete={handleDeleteGuest}
                                                            />
                                                        </React.Fragment>
                                                    ))}
                                            </>
                                        )}
                                    </div>
                                </section>
                            </div>
                        )}



                        {/* Male / Female lists  For invitee */}
                        {userType === "Invitee" && (
                            <div className="agl-two-col">
                                {/* Male Guests */}
                                <section className="agl-card agl-list-card">
                                    <SectionHeader
                                        title="Male Guests"
                                        sub={`${data?.guest_list?.filter((g) => g?.guest_gender === "male").length} Invited • of ${data?.male} Male Guest`}
                                        color="#c7d2fe"
                                    />

                                    <div className="agl-guest-group">
                                        {data?.guest_list?.filter((g) => g?.guest_gender === "male").length === 0 ? (
                                            <div className="agl-subtitle">No Male Guests</div>
                                        ) : (
                                            <>
                                                {/* Host */}
                                                {userType &&
                                                    data?.guest_list
                                                        ?.filter((g) => g.guest_gender === "male" && g.guest_type === "Host")
                                                        .map((g, idx) => (
                                                            <React.Fragment key={`male-host-${idx}`}>
                                                                <div className="agl-subtitle">Host</div>
                                                                <GuestRowHost g={g} male={true} />
                                                            </React.Fragment>
                                                        ))}



                                                {/* Invitee */}
                                                {data?.guest_list
                                                    ?.filter((g) => g.guest_gender === "male" && g.guest_type === "Invitee")
                                                    .map((g, idx) => (
                                                        <React.Fragment key={`male-invitee-${idx}`}>
                                                            {idx === 0 && <div className="agl-subtitle">Invitee</div>}
                                                            <GuestRowInvite
                                                                g={g}
                                                                male={true}
                                                                onEdit={handleEditGuest}
                                                                onDelete={handleDeleteGuest}
                                                                setOpenGivePermission={setOpenGivePermission}
                                                            />
                                                        </React.Fragment>
                                                    ))}


                                                {/* Accompany */}
                                                {data?.guest_list
                                                    ?.filter((g) => g.guest_gender === "male" && g.guest_type === "Accompany")
                                                    .map((g, idx) => (
                                                        <React.Fragment key={`male-accompany-${idx}`}>
                                                            {idx === 0 && <div className="agl-subtitle">Accompany</div>}
                                                            <GuestRow
                                                                g={g}
                                                                male={true}
                                                                onEdit={handleEditGuest}
                                                                onDelete={handleDeleteGuest}
                                                            />
                                                        </React.Fragment>
                                                    ))}
                                            </>
                                        )}
                                    </div>
                                </section>

                                {/* Female Guests */}
                                <section className="agl-card agl-list-card">
                                    <SectionHeader
                                        title="Female Guests"
                                        sub={`${data?.guest_list?.filter((g) => g?.guest_gender === "female").length} Invited • of ${data?.female} Female Guest`}
                                        color="#fbcfe8"
                                    />

                                    <div className="agl-guest-group">
                                        {data?.guest_list?.filter((g) => g?.guest_gender === "female").length === 0 ? (
                                            <div className="agl-subtitle">No Female Guests</div>
                                        ) : (
                                            <>
                                                {/* Host */}
                                                {userType &&
                                                    data?.guest_list
                                                        ?.filter((g) => g.guest_gender === "female" && g.guest_type === "Host")
                                                        .map((g, idx) => (
                                                            <React.Fragment key={`female-host-${idx}`}>
                                                                <div className="agl-subtitle">Host</div>
                                                                <GuestRowHost g={g} male={false} />
                                                            </React.Fragment>
                                                        ))}


                                                {/* Invitee */}
                                                {data?.guest_list
                                                    ?.filter((g) => g.guest_gender === "female" && g.guest_type === "Invitee")
                                                    .map((g, idx) => (
                                                        <React.Fragment key={`male-invitee-${idx}`}>
                                                            {idx === 0 && <div className="agl-subtitle">Invitee</div>}
                                                            <GuestRowInvite
                                                                g={g}
                                                                male={true}
                                                                onEdit={handleEditGuest}
                                                                onDelete={handleDeleteGuest}
                                                                setOpenGivePermission={setOpenGivePermission}
                                                            />
                                                        </React.Fragment>
                                                    ))}


                                                {/* Accompany */}
                                                {data?.guest_list
                                                    ?.filter((g) => g.guest_gender === "female" && g.guest_type === "Accompany")
                                                    .map((g, idx) => (
                                                        <React.Fragment key={`female-accompany-${idx}`}>
                                                            {idx === 0 && <div className="agl-subtitle">Accompany</div>}
                                                            <GuestRow
                                                                g={g}
                                                                male={false}
                                                                onEdit={handleEditGuest}
                                                                onDelete={handleDeleteGuest}
                                                            />
                                                        </React.Fragment>
                                                    ))}
                                            </>
                                        )}
                                    </div>
                                </section>
                            </div>
                        )}


                    </div>

                    {/* RIGHT: Summaries & RSVP */}
                    <aside className="agl-right">
                        <section className="agl-card agl-summary-card">
                            <h4>Guest Summary</h4>
                            <div className="agl-summary-grid">
                                <div className="agl-summary-pair male">
                                    <div className="agl-summary-num ">{data?.male || 0}</div>
                                    <div className="agl-summary-label">Male Guests</div>
                                </div>
                                <div className="agl-summary-pair female">
                                    <div className="agl-summary-num ">{data?.female || 0}</div>
                                    <div className="agl-summary-label">Female Guests</div>
                                </div>
                            </div>
                            <div className="agl-summary-lines">
                                <div className="agl-line">
                                    <span>Total Confirmed</span>
                                    <span className="agl-chip success">{data?.guest_status_info?.yes?.count} Guests</span>
                                </div>
                                <div className="agl-line">
                                    <span>Pending Approval</span>
                                    <span className="agl-chip warn">{data?.guest_status_info?.pending?.count} Guests</span>
                                </div>
                                <div className="agl-line">
                                    <span>Maybe</span>
                                    <span className="agl-chip warn">{data?.guest_status_info?.maybe?.count} Guests</span>
                                </div>
                            </div>
                            <button className="agl-btn agl-btn-primary agl-share">
                                <IoShareSocialOutline /> Share Guest List
                            </button>
                        </section>


                        {/* Payment Summary */}

                        {userType === "Host" && (
                            <section className="agl-card agl-pay-card">
                                <h4>Payment Summary</h4>
                                <div className="agl-pay-row">
                                    <span>Advance Paid</span>
                                    <strong>₹{data?.payable_amount}</strong>
                                </div>
                                <div className="agl-pay-row">
                                    <span>Remaining Balance</span>
                                    <strong>₹{data?.due_amount}</strong>
                                </div>
                                <div className="agl-divider" />
                                <div className="agl-pay-row total">
                                    <span>Total Amount</span>
                                    <strong>₹{data?.total_amount}</strong>
                                </div>
                            </section>
                        )}


                        <section className="agl-card agl-rsvp-card">
                            <div className="agl-rsvp-head">
                                <div className="agl-rsvp-name-text">Name</div>
                                <div className="agl-rsvp-name-text">RSVP</div>
                            </div>
                            <div className="agl-rsvp-list">
                                {data?.guest_list?.map((r, i) => (
                                    <div key={i} className="agl-rsvp-row">
                                        <div className="agl-rsvp-name">
                                            <div className="agl-rsvp-avatar">
                                                {r.avatar || r.guest_name?.[0] || "?"}
                                            </div>
                                            {r.guest_name}
                                        </div>
                                        <RSVPTag s={r.status} />
                                    </div>
                                ))}
                            </div>
                            <button className="agl-link">View More</button>
                        </section>
                    </aside>
                </div>

            </div>

            <AddGuestListModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSubmit={handleSave}
                category={selectedCategory}
                inviteeData={inviteeData}
                userType={userType}
            />

            <GiveGuestAddPermission
                isOpen={openAddGuest}
                onClose={() => setOpenAddGuest(false)}
                onInvite={(data) => handlegiveGuestPermission(data)}
                openGivePermission={openGivePermission}
                data={data}
            />

        </>
    );
}
